export const CONFIRMATION_BUTTON_LABEL_MAX = 32;
export const CONFIRMATION_PROMPT_MAX = 200;
export const CONFIRMATION_RESPONSE_MAX = 500;
/** Legacy notifications and delivered requests retain their original button semantics. */
export function resolveConfirmationButtons(buttons) {
    return (buttons ?? {
        done: { enabled: true, label: 'Сделал', requireText: false, prompt: '' },
        decline: { enabled: true, label: 'Не буду', requireText: true, prompt: '' },
    });
}
//# sourceMappingURL=confirmation-buttons.js.map